import type { ClientPrintAction } from '@nest/domain-printers-backend';
import { Command, usePrintActionHandler } from '@nest/internal-frontend';
import { Printer } from 'lucide-react';
import { toast } from 'sonner';
import { useTerminalClient } from '../../../client-rpc-router';

export const useCommandOutboundDeliveryOrderPrintLabels = ({ id }: { id?: number }): Command => {
	const client = useTerminalClient();

	const printHandler = usePrintActionHandler(
		'outboundDeliveryOrderLabels',
		async (_numberOfCopies, printerIds) => {
			if (id) {
				await client.outboundDeliveryOrders.printPackageLabelsMutation.execute({ id: id, printerIds: printerIds ?? [] });
			}
		},
		{ numberOfCopies: 1, allowedActions: ['print'] as ClientPrintAction[] }
	);

	return {
		id: 'print-labels',
		label: 'Tisk štítků balíků',
		icon: <Printer className="h-4 w-4" />,
		shortcut: undefined,
		disabled: !id,
		loading: printHandler.isLoading,
		run: async () => {
			const ok = await printHandler.run(undefined as never);

			if (ok) {
				toast.success('Štítky byly odeslány na tisk.');
			}
		}
	};
};
